export default "__VITE_ASSET__f2f8e62a__"